import { getFirebase } from './firebase';
var functions = getFirebase().functions();
export var callable = function callable(name) {
  return functions.httpsCallable(name);
};
export var searchFunctionLogsUrl = function searchFunctionLogsUrl(project, search) {
  return "https://console.cloud.google.com/logs/query;query=%22".concat(search, "%22?project=").concat(project);
};
export default functions;